import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import {
  Hero,
  PersonaPanel,
  ServiceLanes,
  ProcessSteps,
  TrustSection,
  TrilogyPreview,
  FamilyTestimonials,
  ResourcesTeaser,
  HomeFaq,
  FinalCTA,
} from "@/components/public/sections";
import { ServiceAreaSearch } from "@/components/public/ServiceAreaSearch";
import { VideoLibrary } from "@/components/public/VideoLibrary";

// Section registry — the Hero is always first; every other section can be
// reordered / hidden from the Homepage Editor (content.section_order + section_visibility).
const SECTIONS = {
  persona: PersonaPanel,
  services: ServiceLanes,
  process: ProcessSteps,
  trust: TrustSection,
  trilogy: TrilogyPreview,
  service_areas: ServiceAreaSearch,
  resources: ResourcesTeaser,
  testimonials: FamilyTestimonials,
  faq: HomeFaq,
  final_cta: FinalCTA,
};
export const DEFAULT_SECTION_ORDER = [
  "persona", "services", "process", "trust", "trilogy",
  "service_areas", "resources", "testimonials", "faq", "final_cta",
];

export default function Home() {
  const { content, openChat, openWelcomeVideo } = useOutletContext();

  useEffect(() => {
    if (content?.seo?.title) document.title = content.seo.title;
  }, [content]);

  const vis = content?.section_visibility || {};
  const stored = Array.isArray(content?.section_order) ? content.section_order.filter((k) => SECTIONS[k]) : [];
  const order = stored.length ? [...stored] : [...DEFAULT_SECTION_ORDER];
  // Insert any new default sections (e.g. faq) at their default position even when a custom order was saved.
  DEFAULT_SECTION_ORDER.forEach((k, i) => {
    if (order.includes(k)) return;
    const prev = DEFAULT_SECTION_ORDER[i - 1];
    const at = prev ? order.indexOf(prev) : -1;
    if (at >= 0) order.splice(at + 1, 0, k); else order.push(k);
  });

  return (
    <div data-testid="public-home">
      <Hero content={content} onChat={openChat} onWelcome={openWelcomeVideo} />
      {order.map((key) => {
        if (vis[key] === false) return null;
        const Cmp = SECTIONS[key];
        if (!Cmp) return null;
        const extra = key === "testimonials" || key === "faq" ? { onChat: openChat } : {};
        return <Cmp key={key} content={content} {...extra} />;
      })}
      <VideoLibrary content={content} />
    </div>
  );
}
